import dayjs from "dayjs";
import { CloseIcon } from "components/atoms/Icon";
import { Typography, Button } from "components/atoms";
import { CONTENT_OBJECT_TYPE_ID, NOT_STARTED, IN_PROGRESS, COMPLETE } from "utils/constants";
import { formatToLocalDate } from "utils/functions/formatToLocalDate";
import { Modal } from "../Modal";
import { DrillSmartHomeWorkRow } from "../DrillSmartHomeWorkRow";
import "./index.scss";

interface IProps {
  handleOnClose: () => void;
  isOpen: boolean;
  data: any;
  theme: "light" | "dark";
  onStartDrill?: (drill: any) => void;
}

export const DrillSmartModal = ({ handleOnClose, isOpen, data, theme, onStartDrill }: IProps) => {
  // const data: any = [
  //   {
  //     Name: "Keep Pluggin Away (Easy 1)",
  //     Status: "Not Started",
  //     ContentObjectTypeId: 12,
  //     DateCompleted: "9999-12-31T23:59:59.9999999",
  //     DeliveryTypes: "None",
  //     Guid: "8e6f1a9d-fc05-4d0a-a3dc-34957d569090",
  //     Id: 1982,
  //     InstanceGuid: "00000000-0000-0000-0000-000000000000",
  //     IsLocked: false,
  //     LaunchUrl:
  //       "https://qa01-dashboard.princetonreview.com/External/LaunchContentObject?contentObjectGuid=8e6f1a9d-fc05-4d0a-a3dc-34957d569090&studentUserGuid=6a4a773e-089d-4484-97cc-f66b5392b88c&pso=MCAT15-SP-TF-180-FTP&isApi=true&newInstance=true",
  //     Url: "",
  //   },
  //   {
  //     Name: "Keep Pluggin Away (Medium 1)",
  //     Status: "In Progress",
  //     ContentObjectTypeId: 12,
  //     DateCompleted: "9999-12-31T23:59:59.9999999",
  //     DeliveryTypes: "None",
  //     Guid: "8e6f1a9d-fc05-4d0a-a3dc-34957d569090",
  //     Id: 1982,
  //     InstanceGuid: "00000000-0000-0000-0000-000000000000",
  //     IsLocked: false,
  //     LaunchUrl:
  //       "https://qa01-dashboard.princetonreview.com/External/LaunchContentObject?contentObjectGuid=8e6f1a9d-fc05-4d0a-a3dc-34957d569090&studentUserGuid=6a4a773e-089d-4484-97cc-f66b5392b88c&pso=MCAT15-SP-TF-180-FTP&isApi=true&newInstance=true",
  //     Url: "",
  //   },
  //   {
  //     Name: "Keep Pluggin Away (Medium 2)",
  //     Status: "In Progress",
  //     ContentObjectTypeId: 12,
  //     DateCompleted: "9999-12-31T23:59:59.9999999",
  //     DeliveryTypes: "None",
  //     Guid: "8e6f1a9d-fc05-4d0a-a3dc-34957d569090",
  //     Id: 1982,
  //     InstanceGuid: "00000000-0000-0000-0000-000000000000",
  //     IsLocked: false,
  //     LaunchUrl:
  //       "https://qa01-dashboard.princetonreview.com/External/LaunchContentObject?contentObjectGuid=8e6f1a9d-fc05-4d0a-a3dc-34957d569090&studentUserGuid=6a4a773e-089d-4484-97cc-f66b5392b88c&pso=MCAT15-SP-TF-180-FTP&isApi=true&newInstance=true",
  //     Url: "",
  //   },
  //   {
  //     Name: "Keep Pluggin Away (Hard 1)",
  //     Status: "Completed",
  //     ContentObjectTypeId: 12,
  //     DateCompleted: "9999-12-31T23:59:59.9999999",
  //     DeliveryTypes: "None",
  //     Guid: "8e6f1a9d-fc05-4d0a-a3dc-34957d569090",
  //     Id: 1982,
  //     InstanceGuid: "00000000-0000-0000-0000-000000000000",
  //     IsLocked: false,
  //     LaunchUrl:
  //       "https://qa01-dashboard.princetonreview.com/External/LaunchContentObject?contentObjectGuid=8e6f1a9d-fc05-4d0a-a3dc-34957d569090&studentUserGuid=6a4a773e-089d-4484-97cc-f66b5392b88c&pso=MCAT15-SP-TF-180-FTP&isApi=true&newInstance=true",
  //     Url: "",
  //   },
  // ];

  return (
    <Modal isOpen={isOpen} onClose={handleOnClose} theme={theme}>
      <div className="drill-smart-modal-wrapper">
        <div className="drill-smart-modal-header">
          <div className="drill-smart-modal-header-typography">
            <div className="title-typography-wrapper">
              <Typography
                label={data?.groupName || "DrillSmart"}
                variant="h6Medium"
                styles="drill-smart-modal-header-typography-custom-style"
              />
            </div>
          </div>
          <div
            className="drill-smart-modal-header-close-icon"
            onClick={handleOnClose}
          >
            <CloseIcon theme={theme} />
          </div>
        </div>
        <div className="drill-smart-modal-body">
          <div className="drill-smart-modal-intro-section">
            <div className="title-wrapper">
              <Typography label={`Drill`} variant="h1Med" />
              <Typography
                label={`Smart`}
                variant="h1Bold"
                styles="smart-text-style"
              />
              <Typography
                label={`Your best way to practice!`}
                variant="h9Medium"
                styles="subtext-style"
              />
            </div>
            {(() => {
              // Check if content is locked first
              const isLocked = data?.isLocked === true;
              
              // Determine state based on DrillSmartResult status
              const drillSmartStatus = data?.drillSmartResult?.Status || "NotStarted";
              const moveNext = data?.drillSmartResult?.MoveNext || false;
              const isNotStarted = drillSmartStatus === "NotStarted" || drillSmartStatus === "Not Started";
              const isInProgress = drillSmartStatus === "InProgress" || drillSmartStatus === "In Progress";
              const isCompleted = drillSmartStatus === "Completed" || drillSmartStatus === "Complete";
              
              // Determine button text
              let buttonLabel = "Start DrillSmart";
              if (isLocked) {
                buttonLabel = "Unlock All Content";
              } else if (isNotStarted) {
                buttonLabel = "Start DrillSmart";
              } else if (isInProgress) {
                buttonLabel = "Continue DrillSmart";
              } else if (isCompleted) {
                buttonLabel = "Restart DrillSmart";
              }
              
              // Find the next drill to display
              // First check if NextDrill is explicitly set
              let nextDrillToShow = data?.nextDrill;
              
              // If not set but MoveNext is true, try to find the recommended drill from content
              if (!nextDrillToShow && moveNext && data?.content && Array.isArray(data.content)) {
                // Find the first drill that is not completed and not in progress
                const recommendedDrill = data.content.find((drill: any) => {
                  const drillStatus = drill.Status || "Not Started";
                  return !COMPLETE.includes(drillStatus) && !IN_PROGRESS.includes(drillStatus);
                });
                if (recommendedDrill) {
                  nextDrillToShow = recommendedDrill;
                }
              }
              
              // Show completion message if completed, otherwise show description
              const showCompletionMessage = isCompleted;
              
              return (
                <>
                  {showCompletionMessage ? (
                    <Typography
                      label={`You've completed your DrillSmart! See below for additional practice.`}
                      variant="h7Med"
                    />
                  ) : (
                    <>
                      <Typography
                        label={`First, you'll take a calibration drill and based on your results you'll get a follow-up drill that's at the right level for you... just like on GRE!`}
                        variant="h7Med"
                      />
                      <div className="drill-smart-button-container">
                        <Button
                          icon={false}
                          label={buttonLabel}
                          type="score"
                          onClick={() => {
                            if (isLocked) {
                              // Handle unlock action - this should navigate to unlock page or open unlock modal
                              // For now, we'll just return as the parent component should handle this
                              return;
                            }
                            if (data.drillSmartLaunchUrl == null) {
                              console.warn("drillSmartLaunchUrl is null");
                              return;
                            }
                            if (onStartDrill) {
                              onStartDrill({ ContentObjectType: "DrillSmart" });
                            } else {
                              window.open(data.drillSmartLaunchUrl, "__blank");
                            }
                          }}
                          isLoading={false}
                        />
                        {/* Show NEXT drill when In Progress and nextDrill exists */}
                        {isInProgress && nextDrillToShow && (
                          <Typography
                            label={`NEXT: ${nextDrillToShow.Name || nextDrillToShow.name || "Continue to next drill"}`}
                            variant="h7Med"
                            styles="drill-smart-next-drill-style"
                          />
                        )}
                      </div>
                    </>
                  )}
                </>
              );
            })()}
          </div>
          <div className="drill-smart-modal-choose-drill-section">
            <Typography label={`Choose a Drill`} variant="h1Med" />
            <Typography
              label={`Here’s the full list of drills available in this topic area. Do as many as you’d like, at any difficulty level.`}
              variant="h7Med"
            />
            <div className="drill-contentobject-wrapper">
              {data?.content ? data.content.map((value: any, index: number) => {
                // Determine status for consistent handling
                const status = value.Status || "Not Started";
                const isLocked = value.Status === "Lock" || value.IsLocked === true;
                const isNotStarted = NOT_STARTED.includes(status);
                const isInProgress = IN_PROGRESS.includes(status);
                const isCompleted = COMPLETE.includes(status);
                
                // Check if this is the recommended next drill
                const nextGuid = data?.nextDrill?.ContentObjectGuid;
                const valueGuid = value.ContentObjectGuid ?? value.Guid;
                const isRecommendedDrill = Boolean(
                  nextGuid && valueGuid && nextGuid === valueGuid
                );
                
                // Determine icon type
                // If it's the recommended drill and in progress state, use special icon
                let iconType: "lock" | "empty-circle" | "select" | "yellow-timer" | "arrow-right" = "empty-circle";
                if (isLocked) {
                  iconType = "lock";
                } else if (isCompleted) {
                  iconType = "select";
                } else if (isInProgress) {
                  iconType = "yellow-timer";
                } else if (isNotStarted) {
                  // If it's the recommended drill, show arrow-right icon
                  iconType = isRecommendedDrill ? "arrow-right" : "empty-circle";
                }
                
                // Determine middle label (status text)
                let middleLabel = "Not Started";
                if (isCompleted && value.DateCompleted) {
                  middleLabel = `Completed on ${formatToLocalDate(value.DateCompleted, "MM/DD/YYYY")}`;
                } else if (isLocked) {
                  middleLabel = "Locked";
                } else if (isInProgress) {
                  middleLabel = "In Progress";
                } else if (isNotStarted) {
                  middleLabel = "Not Started";
                }
                
                return (
                  <DrillSmartHomeWorkRow
                    key={index}
                    index={index}
                    textIconLabel={value.Name}
                    iconType={iconType}
                    middleLabel={middleLabel}
                        handlePrimaryBtnClick={() => {
                            if (value.LaunchUrl && onStartDrill) {
                              // Parent opens URL via openExternalUrl so refresh modal is shown
                              onStartDrill(value);
                            } else if (value.LaunchUrl) {
                              window.open(value.LaunchUrl, "__blank");
                            }
                    }}
                    handleSecondaryBtnClick={() => value.ScoreReportUrl && window.open(value.ScoreReportUrl, "__blank")}
                    status={status}
                    isLocked={isLocked}
                    contentObjectType={
                      value.ContentObjectType
                        ? value.ContentObjectType
                        : Object.keys(CONTENT_OBJECT_TYPE_ID).find(
                            (key: string) =>
                              CONTENT_OBJECT_TYPE_ID[key] === value.ContentObjectTypeId
                          )
                    }
                    theme={theme}
                    isRecommended={isRecommendedDrill}
                  />
                );
              }): null}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};
